import { useRouter } from "next/router";
import React, { memo, useEffect, useState } from "react";
import { BsSearch } from "@react-icons/all-files/bs/BsSearch";
import { SearchBlog } from "../api";
import SidebarContentItem from "./SidebarContentItem";
import { useTranslation } from "../../context/TranslationContext";

const Sidebar = ({ SearchOnSubmit, LastShared, Popular }) => {
  const {
    blogSidebarSearchTitle,
    blogSidebarSearchPlaceHolder,
    blogSidebarList1Title,
    blogSidebarList2Title,
  } = useTranslation();
  const [searchText, setSearchText] = useState("");

  const router = useRouter();
  const HandleSubmit = (e) => {
    e.preventDefault();
    SearchOnSubmit(searchText);

    // const { query } = router;
    // query.slug = [url];

    // if (searchText) {
    //   query.search = searchText;
    // } else {
    //   delete query.search;
    // }
    // router.replace(
    //   {
    //     query: query,
    //   },
    //   undefined,
    //   {
    //     scroll: true,
    //     shallow: true,
    //   }
    // );
    // SearchBlog(searchText).then((e) => {
    //   setData(e.data.result.BlogData.result);
    // });
  };

  return (
    <div className="lg:col-span-4 col-span-12">
      <div className="flex flex-col mb-8">
        <h2 className="text-xl font-semibold mb-1">{blogSidebarSearchTitle}</h2>
        <form onSubmit={HandleSubmit} className="flex">
          <div className="flex flex-row justify-between pt-2 w-full">
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="border border-3  w-full py-3 rounded-l focus:outline-none  text-black pl-2 font-medium"
              placeholder={blogSidebarSearchPlaceHolder}
            ></input>
            <button
              type="submit"
              className="btn rounded-0 rounded-end flex items-center content-center bg-slate-200 px-3 rounded-r"
            >
              <BsSearch />
            </button>
          </div>
        </form>
      </div>
      <div className="flex flex-col mb-8">
        <h2 className="text-xl font-semibold mb-1">{blogSidebarList1Title}</h2>
        {LastShared.map((e, i) => (
          <SidebarContentItem data={e} key={i} />
        ))}
      </div>
      <div className="flex flex-col">
        <h2 className="text-xl font-semibold mb-1">{blogSidebarList2Title}</h2>
        {Popular.map((e, i) => (
          <SidebarContentItem data={e} key={i} />
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
